import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo, useMemo } from "react";
import dynamic from "next/dynamic";
import { CardContextProvider } from "@/components/Card/CardContext";
import { usePaletteQuery } from "@/hooks";
import { SLIDER_MAX_NUM } from "@/lib/constants";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PaletteContent = dynamic(function () {
  return import("@/components/PaletteContent");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/PaletteContent")];
    }
  }
});
var MyListPalette = dynamic(function () {
  return import("@/components/MyListPalette");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/MyListPalette")];
    }
  }
});
var GenrePalette = dynamic(function () {
  return import("@/components/GenrePalette");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/GenrePalette")];
    }
  }
});
var EntitledPalette = dynamic(function () {
  return import("@/components/EntitledPalette");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/EntitledPalette")];
    }
  }
});
var RankingPalette = dynamic(function () {
  return import("@/components/RankingPalette");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/RankingPalette")];
    }
  }
});
var EntitledHtmlSnippetPalette = dynamic(function () {
  return import("@/components/EntitledHtmlSnippetPalette");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/EntitledHtmlSnippetPalette")];
    }
  }
});

function Palette(_ref) {
  var _palette$values, _palette$values2, _palette$values3;

  var id = _ref.id,
      hiddenPrice = _ref.hiddenPrice;

  var _usePaletteQuery = usePaletteQuery({
    variables: {
      id: id,
      offset: 0,
      limit: SLIDER_MAX_NUM
    }
  }),
      data = _usePaletteQuery.data,
      result = _objectWithoutProperties(_usePaletteQuery, _excluded);

  var palette = data === null || data === void 0 ? void 0 : data.palette;
  var paletteObjects = data === null || data === void 0 ? void 0 : data.paletteObjects;
  var items = useMemo(function () {
    if (paletteObjects) {
      var metas = paletteObjects.data.map(function (data) {
        return data.meta || data.advertising;
      });
      return {
        data: metas,
        pageInfo: paletteObjects.pageInfo
      };
    } else {
      return null;
    }
  }, [paletteObjects]);
  var header = {
    text: (palette === null || palette === void 0 ? void 0 : palette.header) || (palette === null || palette === void 0 ? void 0 : palette.name)
  };

  if ((palette === null || palette === void 0 ? void 0 : (_palette$values = palette.values) === null || _palette$values === void 0 ? void 0 : _palette$values.view_type) !== "grid") {
    header["link"] = {
      href: routes.palette(palette === null || palette === void 0 ? void 0 : palette.palette_id)
    };
  }

  return /*#__PURE__*/_jsxs(CardContextProvider, {
    hiddenPrice: hiddenPrice,
    children: [(palette === null || palette === void 0 ? void 0 : palette.schema) === "default" && /*#__PURE__*/_jsx(PaletteContent, _objectSpread({
      id: id,
      viewType: palette === null || palette === void 0 ? void 0 : (_palette$values2 = palette.values) === null || _palette$values2 === void 0 ? void 0 : _palette$values2.view_type,
      header: header,
      largeCard: palette === null || palette === void 0 ? void 0 : (_palette$values3 = palette.values) === null || _palette$values3 === void 0 ? void 0 : _palette$values3.large_card_for_slider,
      items: items
    }, result)), (palette === null || palette === void 0 ? void 0 : palette.schema) === "mylist" && /*#__PURE__*/_jsx(MyListPalette, {
      palette: palette
    }), (palette === null || palette === void 0 ? void 0 : palette.schema) === "genre" && /*#__PURE__*/_jsx(GenrePalette, {
      palette: palette
    }), (palette === null || palette === void 0 ? void 0 : palette.schema) === "entitled" && /*#__PURE__*/_jsx(EntitledPalette, {
      palette: palette
    }), (palette === null || palette === void 0 ? void 0 : palette.schema) === "ranking" && /*#__PURE__*/_jsx(RankingPalette, {
      palette: palette
    }), (palette === null || palette === void 0 ? void 0 : palette.schema) === "entitled_html_snippet" && /*#__PURE__*/_jsx(EntitledHtmlSnippetPalette, {
      palette: palette
    })]
  });
}

export default /*#__PURE__*/memo(Palette);